import { css } from 'styled-components';

import { floorGameColor as color } from '@pkg/primitives';

export const overlayBase = css`
    position: absolute;
    width: 100%;
    height: 100%;
`;

export const tokens = {
    fallback: {
        gradient: `linear-gradient(134deg, ${color.blackberry} 14%, ${color.grapeDark} 90%)`,
    },
    skeleton: {
        gradient: `linear-gradient(134deg, ${color.blackberry} 14%, ${color.blackberryDark} 90%)`,
    },
};
